// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"597":"75ed49ca","822":"cf376b33"}[chunkId] + ".chunk.css";
};